import { render, staticRenderFns } from "./Correspondence.vue?vue&type=template&id=c7b9ad1e&scoped=true&"
import script from "./Correspondence.vue?vue&type=script&lang=js&"
export * from "./Correspondence.vue?vue&type=script&lang=js&"
import style0 from "./Correspondence.vue?vue&type=style&index=0&id=c7b9ad1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b9ad1e",
  null
  
)

export default component.exports